/**
 * HTTP body builders for v3 seat block/unblock (see docs/API_PROPOSAL_SEAT_BLOCK.md).
 */

/**
 * @param {{ type?: string, seatId: string, sectionId: string, col: number, row?: number, rowLabel?: string|number, seatNumber?: string|number, seatClass?: string|null, syncEntryId?: string|null }} seat
 * @param {string|null|undefined} fareId
 * @param {string|null|undefined} [syncEntryId] - kiosk-generated UUID; also read from seat.syncEntryId
 */
export function buildBlockPayload(seat, fareId = null, syncEntryId = null) {
  const resolvedSync = syncEntryId ?? seat?.syncEntryId ?? null
  console.log("buildBlockPayload seat: ", seat)
  // Betterez PATCH expects collection rowLabel (string), not grid seat.row.
  const body = {
    step: seat.type === "return" ? "return" : "departure",
    seatId: seat.seatId,
    sectionId: seat.sectionId,
    col: seat.col,
    row: seat.rowLabel != null && seat.rowLabel !== ""
      ? String(seat.rowLabel)
      : seat.row,
    seat: seat.seatNumber,
    seatClass: seat.seatClass ?? null,
    fareId: fareId == null || fareId === "" ? null : fareId,
    // Always include the key: PHP 8 on api.transpais.* does $body['syncEntryId']
    // and throws "Undefined array key" when it is omitted.
    syncEntryId:
      resolvedSync != null && resolvedSync !== ""
        ? String(resolvedSync)
        : null,
  }

  return body
}

/**
 * Same shape as block; liberation key is session + step + seatId.
 * @param {{ type?: string, seatId: string, sectionId: string, col: number, row?: number, rowLabel?: string|number, seatNumber?: string|number, seatClass?: string|null, syncEntryId?: string|null }} seat
 * @param {string|null|undefined} fareId - capture before clearing passenger state
 * @param {string|null|undefined} [syncEntryId]
 */
export function buildUnblockPayload(seat, fareId = null, syncEntryId = null) {
  return buildBlockPayload(seat, fareId, syncEntryId)
}
